import { useMutation } from '@tanstack/react-query'
import { deploymentGroupApi } from '@/api/deploymentGroupApi'

export const useStopDeploymentGroup = () => {
  return useMutation({
    mutationFn: deploymentGroupApi.stopDeploymentGroup
  })
}

export const useStartDeploymentGroup = () => {
  return useMutation({
    mutationFn: deploymentGroupApi.startDeploymentGroup
  })
}

export const useRestartDeploymentGroup = () => {
  return useMutation({
    mutationFn: deploymentGroupApi.restartDeploymentGroup
  })
}

export const useRemoveDeploymentGroup = () => {
  return useMutation({
    mutationFn: deploymentGroupApi.removeDeploymentGroup
  })
}
